import script from "./Template-002.vue?vue&type=script&lang=ts&setup=true"
export * from "./Template-002.vue?vue&type=script&lang=ts&setup=true"

import "./Template-002.vue?vue&type=style&index=0&id=62b3d5b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b3d5b8"]])

export default __exports__